<div class="space-y-6 mb-6">
  <h3 class="text-lg font-semibold">
    {{ 'project.steps.rfi.invitationPreview.tabProjectDescription.header' | transloco }}
  </h3>
</div>

<div class="space-y-6" data-testid="rfi-invitation-text-sections">
  @for (section of invitationSections(); track section.key) {
    <div class="space-y-4" [attr.data-testid]="'section-' + section.key">
      <div class="w-full">
        <app-rich-text-editor
          [key]="section.key"
          [tooltipKey]="section.tooltipKey"
          [initialContent]="section.content"
          [saveHandler]="richTextService"
          [disabled]="isButtonDisabled()"
          (statusChange)="onStatusChange()"
          class="w-full"
          [attr.data-testid]="'rich-text-editor-' + section.key"
        >
        </app-rich-text-editor>
      </div>
    </div>
    @if (section.key.includes('beginning_text')) {
      <div
        class="card space-y-4 border border-gray-700 rounded-lg p-4"
        data-testid="generated-text-section"
      >
        @if (descriptionLoading()) {
          <div data-testid="generated-text-loading">
            <app-loading [size]="LoadingSize.MIDDLE" />
          </div>
        } @else if (formattedContent()) {
          <div class="flex justify-end">
            <app-ai-generated-label [provenance]="descriptionProvenance()" />
          </div>
          <div
            class="prose prose-sm max-w-none"
            [innerHTML]="formattedContent()"
            data-testid="generated-text-content"
          ></div>
        } @else {
          <p class="text-sm text-gray-500 italic">
            {{ 'projectSequence.step72.sections.generatedText.placeholder' | transloco }}
          </p>
        }
      </div>
    }
  }
</div>
